import { ReactNode } from 'react';

interface PageTransitionWrapperProps {
  children: ReactNode;
}

export function PageTransitionWrapper({ children }: PageTransitionWrapperProps) {
  // Render children immediately — no opacity:0 → 1 animation.
  // The previous fade-in (opacity 0→1 over 150ms) was adding render delay
  // to the LCP element (H1), inflating LCP by hundreds of milliseconds.
  return (
    <div style={{ minHeight: '100vh' }}>
      {children}
    </div>
  );
}
